import { render, staticRenderFns } from "./LcCellText.vue?vue&type=template&id=2edf9678"
import script from "./LcCellText.vue?vue&type=script&lang=js"
export * from "./LcCellText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports